// extracted by mini-css-extract-plugin
export var centerList = "_j1-6";
export var centerLoc = "_j1-a";
export var centerName = "_j1-9";
export var centerOptionBody = "_j1-8";
export var centerRow = "_j1-7";
export var centerStatus = "_j1-b";
export var empty = "_j1-5";
export var externalIcon = "_j1-c";
export var fieldHeader = "_j1-2";
export var fieldHelp = "_j1-4";
export var fieldLabel = "_j1-3";
export var panel = "_j1-0";
export var removeBtn = "_j1-d";
export var section = "_j1-1";